// extracted by mini-css-extract-plugin
export var categoriesLarge = "navbar-module--categories-large--pNWBy";
export var bigScreen = "navbar-module--big-screen--3gY0-";
export var medScreen = "navbar-module--med-screen--3N0-a";
export var categoriesSmall = "navbar-module--categories-small--1MocZ";
export var results = "navbar-module--results--10piY";
export var navButtons = "navbar-module--nav-buttons--2zqao";